import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { ApiCategoriesService } from './_api/api-catalog/api-categories/api-categories.service';
import { ApiProductsService } from './_api/api-catalog/api-products/api-products.service';
import { ApiStoresService } from './_api/api-catalog/api-stores/api-stores.service';
import { ApiPromotionService } from './_api/api-promotions/api-promotions.service';
import { ApiSecureService } from './_api/api-secure/api-secure.service';
import { ApiShippingService } from './_api/api-shipping/api-shipping.service';
import { ApiRequestService } from './_api/api-util/api-request.service';
import { CacheInterceptor } from './_api/api-util/cache/cache.interceptor';
import { CacheService } from './_api/api-util/cache/cache.service';
import { ApiSeoService } from './_api/api-web/api-seo/api-seo.service';
import { ApiCmsConfigurationsService } from './_api/providers/api-cms/api-cms-configurations/api-cms-configurations.service';
import { ApiCmsTranslationsService } from './_api/providers/api-cms/api-cms-translations/api-cms-translations.service';
import { ApiColbensonService } from './_api/providers/api-colbenson/api-colbenson.service';
import { CategoriesService } from './catalog/categories/categories.service';
import { ProductsService } from './catalog/products/products.service';
import { EcommerceRequestInterceptor } from './errors/request-interceptor';
import { SecureService } from './secure/secure.service';
import { SeoService } from './seo/seo.service';
import { EcommerceUrlResolverService } from './shared/url-resolver/ecommerce-url-resolver.service';
import { ShippingService } from './shipping/shipping.service';
import { StoresService } from './stores/stores.service';


@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [],
  providers: [
    // Services
    StoresService,
    CategoriesService,
    ProductsService,
    ShippingService,
    SeoService,
    SecureService,
    EcommerceUrlResolverService,

    // Api raw requests services
    ApiStoresService,
    ApiCategoriesService,
    ApiProductsService,
    ApiPromotionService,
    ApiShippingService,
    ApiSeoService,
    ApiCmsConfigurationsService,
    ApiCmsTranslationsService,
    ApiColbensonService,
    ApiSecureService,

    // Support
    ApiRequestService,
    { provide: HTTP_INTERCEPTORS, useClass: EcommerceRequestInterceptor, multi: true },
    CacheService,
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
  ]
})
export class IdtEcommerceApiModule { }
